const state = {
  pythonStore:
    [
      {
        id: 1,
        title_en: "Python 3.8.6 Starter",
        title_ua: "Python 3.8.6 Стартовий",
        title_es: "Python 3.8.6 Inicio",
        regnumber: "TP34890769",
        grade: "1000 / 1000",
        examdate: "07.10.2022",
        image: "https://testprovider.com/ru/search-certificate/tp34890769",
      },
      {
        id: 2,
        title_en: "Python 3.8.6 Essential",
        title_ua: "Python 3.8.6 Базовий",
        title_es: "Python 3.8.6 Básico",
        regnumber: "TP37206931",
        grade: "1000 / 1000",
        examdate: "18.10.2022",
        image: "https://testprovider.com/ru/search-certificate/tp37206931",
      },
      {
        id: 3,
        title_en: "Python Advanсed",
        title_ua: "Python Поглиблений",
        title_es: "Python Avanzado",
        regnumber: "TP30334066",
        grade: "1000 / 1000",
        examdate: "25.10.2022",
        image: "https://testprovider.com/ru/search-certificate/tp30334066",
      },
      {
        id: 4,
        title_en: "Flask",
        title_ua: "Flask",
        title_es: "Flask",
        regnumber: "TP35918152",
        grade: "1000 / 1000",
        examdate: "28.10.2022",
        image: "https://testprovider.com/ru/search-certificate/tp35918152",
      },
      {
        id: 5,
        title_en: "Django Starter",
        title_ua: "Django Стартовий",
        title_es: "Django Inicio",
        regnumber: "TP36453931",
        grade: "1000 / 1000",
        examdate: "10.11.2022",
        image: "https://testprovider.com/ru/search-certificate/tp36453931",
      },
      {
        id: 6,
        title_en: "Django Essential",
        title_ua: "Django Базовий",
        title_es: "Django Básico",
        regnumber: "TP28729679",
        grade: "1000 / 1000",
        examdate: "16.11.2022",
        image: "https://testprovider.com/ru/search-certificate/tp28729679",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};